import React from 'react'

type Props = {
  currentStep: number
}

function CreditApplicationContainerStepProgressIcon({ currentStep }: Props) {
  const styleCheck = {
    '--fa-primary-color': 'white',
    '--fa-secondary-color': '#08abf0',
    '--fa-secondary-opacity': 1.0,
  } as React.CSSProperties

  const styleNumber = {
    '--fa-primary-color': 'white',
    '--fa-secondary-color': 'dimgray',
    '--fa-secondary-opacity': 0.8,
  } as React.CSSProperties

  const stepStatus = (step: number) => {
    if (currentStep >= step) {
      return 'fa-duotone fa-circle-check'
    }
    return `fa-duotone fa-circle-${step}`
  }

  const stepStyle = (step: number) => {
    if (currentStep >= step) {
      return styleCheck
    }
    return styleNumber
  }

  return (
    <div className="after-steps-container" style={{ marginBottom: '5rem' }}>
      <ul className="steps">
        <li className="after-steps">
          <a href="step1">
            <i className="fa-duotone fa-circle-check" style={styleCheck} />
          </a>
        </li>
        <li className="after-steps">
          <a href="step1">
            <i className={stepStatus(2)} style={stepStyle(2)} />
          </a>
        </li>
        <li className="after-steps">
          <a href="step1">
            <i className={stepStatus(3)} style={stepStyle(3)} />
          </a>
        </li>
        <li className="after-steps">
          <a href="step1">
            <i className={stepStatus(4)} style={stepStyle(4)} />
          </a>
        </li>
      </ul>
    </div>
  )
}

export default CreditApplicationContainerStepProgressIcon
